import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "application/json";

// Переменные для управления очередью запросов при обновлении токена
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
	failedQueue.forEach((prom) => {
		if (error) {
			prom.reject(error);
		} else {
			prom.resolve(token);
		}
	});
	failedQueue = [];
};

axios.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;

		// Не обрабатываем ошибки самого запроса на обновление
		if (originalRequest.url.includes("/api/token/refresh")) {
			return Promise.reject(error);
		}

		// Если получили 401 и это не повторный запрос
		if (error.response?.status === 401 && !originalRequest._retry) {
			const store = window.storeInstance;
			
			if (isRefreshing) {
				// Если обновление уже запущено другим запросом, встаем в очередь
				return new Promise((resolve, reject) => {
					failedQueue.push({ resolve, reject });
				})
					.then((token) => {
						originalRequest.headers["Authorization"] =
							`Bearer ${token}`;
						return axios(originalRequest);
					})
					.catch((err) => Promise.reject(err));
			}

			originalRequest._retry = true;
			isRefreshing = true;

			const refreshToken = localStorage.getItem("refresh_token");
			const deviceId = localStorage.getItem("device_id");

			if (!refreshToken) {
				isRefreshing = false;
				return Promise.reject(error);
			}

			try {
				// Выполняем запрос на обновление
				const { data } = await axios.post("/api/token/refresh", {
					refresh_token: refreshToken,
					device_id: deviceId,
				});
				
				const {
					access_token: accessToken,
					refresh_token: newRefreshToken,
				} = data;

				// Сохраняем новые данные
				localStorage.setItem("access_token", accessToken);
				localStorage.setItem("refresh_token", newRefreshToken);

				axios.defaults.headers.common["Authorization"] =
					`Bearer ${accessToken}`;
				originalRequest.headers["Authorization"] =
					`Bearer ${accessToken}`;

				// Обновляем данные в Vuex
				if (store?.state?.app?.auth) {
					const authModel = store.state.app.auth;
					authModel.accessToken = accessToken;
					authModel.refreshToken = newRefreshToken;
					authModel.deviceId = data.device_id;
				}

				// Пропускаем все накопившиеся запросы с новым токеном
				processQueue(null, accessToken);

				return axios(originalRequest);
			} catch (refreshError) {
				processQueue(refreshError, null);

				// Полная очистка при критической ошибке обновления
				if (store?.state?.app?.auth) {
					store.state.app.auth.doLogout();
				}

				localStorage.clear();
				if (window.location.pathname !== "/login") {
					window.location.href = "/login";
				}

				return Promise.reject(refreshError);
			} finally {
				isRefreshing = false;
			}
		}

		return Promise.reject(error);
	},
);

export default axios;
